


















































import Vue from 'vue';
import QuizContentNavCard from '@/web/components/quizzes/QuizContentNavCard.vue';
import AddQuizQuestionModal from '@/web/components/quizzes/AddQuizQuestionModal.vue';
import { draggableDelay } from '@/web/utils/draggable';
import draggable from 'vuedraggable';
import { errorToMessage } from '@/core/utils/errors';
import HMDialog from '@/web/components/common/HMDialog.vue';
import DirtyMixin from '@/web/mixins/DirtyMixin';
// Forms
import QuizStartScreenForm from '@/web/components/quizzes/QuizStartScreenForm.vue';
import QuizFinishScreenForm from '@/web/components/quizzes/QuizFinishScreenForm.vue';
import QuizImageSelectForm from '@/web/components/quizzes/QuizImageSelectForm.vue';
import QuizeABCDSelectForm from '@/web/components/quizzes/QuizeABCDSelectForm.vue';
import QuizMultipleChoiceSelectForm from '@/web/components/quizzes/QuizMultipleChoiceSelectForm.vue';
import QuizTrueFalseScreenForm from '@/web/components/quizzes/QuizTrueFalseScreenForm.vue';
import QuizTypedAnswerSelectForm from '@/web/components/quizzes/QuizTypedAnswerForm.vue';
import QuizFileUploadSelectForm from '@/web/components/quizzes/QuizFileUploadForm.vue';
import QuizOpinionScaleForm from '@/web/components/quizzes/QuizOpinionScaleForm.vue';

import { mapGetters } from 'vuex';

const cardsMapper = {
  start_screen: QuizStartScreenForm,
  finish_screen: QuizFinishScreenForm,
  single_image: QuizImageSelectForm,
  single_choice: QuizeABCDSelectForm,
  multiple_choice: QuizMultipleChoiceSelectForm,
  boolean: QuizTrueFalseScreenForm,
  typed_answer: QuizTypedAnswerSelectForm,
  file_upload: QuizFileUploadSelectForm,
  opinion_scale: QuizOpinionScaleForm,
};

export default Vue.extend({
  name: 'QuizContent',
  mixins: [DirtyMixin],
  components: {
    QuizContentNavCard,
    QuizStartScreenForm,
    QuizImageSelectForm,
    draggable,
  },
  data() {
    return {
      draggableDelay,
      selectContentCardId: 'start_screen',
      updatingCardId: null,
    };
  },
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
      isDirty: 'globals/isDirty',
      formSaveFun: 'globals/formSaveFun',
    }),
    quizQuestions: {
      get() {
        return this.quiz.quiz_questions;
      },
      set(questions) {
        this.$store.dispatch('quiz/reorderQuizQuestions', {
          quizId: this.quiz.id,
          questions,
        });
      },
    },
    activeCardData() {
      const selectedId = this.selectContentCardId;
      if (['start_screen', 'finish_screen'].includes(selectedId)) {
        return this.quiz;
      } else {
        const question = this.quiz.quiz_questions.find(
          ({ id }) => id === selectedId
        );
        return question;
      }
    },
    currentCard() {
      const selectedId = this.selectContentCardId;
      if (['start_screen', 'finish_screen'].includes(selectedId)) {
        return cardsMapper[selectedId];
      } else {
        const question = this.quiz.quiz_questions.find(
          ({ id }) => id === selectedId
        );
        return cardsMapper[question.question_type];
      }
    },
  },
  methods: {
    async saveForm() {
      if (this.isDirty) {
        this.updatingCardId = this.selectContentCardId;
        const promise = this.formSaveFun();
        promise.finally(() => (this.updatingCardId = null));
        return promise;
      }
    },
    async setSelectContentCardId(id) {
      if (this.updatingCardId) return;
      await this.saveForm();
      this.selectContentCardId = id;
      /*
      if (this.isDirty) {
        this.$modal.show(HMDialog, {
          title: this.$t('GENERAL.TITLE.DISCARD_CHANGES'),
          subtitle: this.$t('GENERAL.TEXT.DO_YOU_REALLY_WANT_TO_DO_IT'),
          text: this.$t('GENERAL.TEXT.UNSAVED_CHANGES_WILL_BE_LOST'),
          confirmButton: this.$t('GENERAL.BUTTON.STAY_ON_PAGE'),
          discardButton: this.$t('GENERAL.BUTTON.LEAVE'),
          confirm: () => {},
          discard: () => {
            this.selectContentCardId = id;
          },
        });
      } else {
        this.selectContentCardId = id;
      }
      */
    },
    addNewQuestion() {
      this.saveForm();
      this.$modal.show(
        AddQuizQuestionModal,
        {
          quizId: this.quiz.id,
          position: this.quiz.quiz_questions.length + 1,
        },
        {},
        {
          'question-added': question => {
            this.$store.dispatch('quiz/addQuizQuestion', question);
            this.setSelectContentCardId(question.id);
          },
        }
      );
    },
    reorderQuestions(questions) {
      this.$store.dispatch('quiz/reorderQuizQuestions', {
        quizId: this.quiz.id,
        questions,
      });
    },
    async duplicate(question: QuizQuestionResponse): Promise<void> {
      await this.saveForm();
      try {
        const duplicate = await this.$store.dispatch(
          'quiz/duplicateQuizQuestion',
          {
            quizId: question.quiz,
            questionId: question.id,
          }
        );
        this.$store.dispatch('quiz/addQuizQuestion', duplicate);
        this.setSelectContentCardId(duplicate.id);

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t(
            'QUIZZES.MODAL.QUESTION_DUPLICATED_DESCRIPTION'
          ) as string,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_DUPLICATE_QUIZ_QUESTION'
            )}: ${error}`
          ),
          duration: -1,
        });
      }
    },
    async remove(question: QuizQuestionResponse): Promise<void> {
      try {
        await this.$store.dispatch('quiz/deleteQuizQuestion', {
          quizId: this.quiz.id,
          questionId: question.id,
        });
        this.$store.dispatch('quiz/removeQuizQuestion', question.id);

        await this.$store.dispatch('quiz/reorderQuizQuestions', {
          quizId: this.quiz.id,
          questions: this.quiz.quiz_questions,
        });

        if (question.id === this.selectContentCardId) {
          this.setSelectContentCardId('start_screen');
        }

        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS') as string,
          text: this.$t('QUIZZES.MODAL.QUESTION_DELETED_DESCRIPTION') as string,
        });
        this.quizQuestions = this.quizQuestions.filter(
          item => item.id !== question.id
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_DELETE_QUIZ_QUESTION'
            )}: ${error}`
          ),
          duration: -1,
        });
      }
    },
  },
});
